import analytics from '@banking/ui/workflows/utils/analytics';
import events from './debit-card-settings-events';
export let EventLogging;
(function (_EventLogging) {
  let Action = /*#__PURE__*/function (Action) {
    Action["Click"] = "Click";
    Action["View"] = "View";
    return Action;
  }({});
  _EventLogging.Action = Action;
  let Feature = /*#__PURE__*/function (Feature) {
    Feature["DebitCardSettings"] = "Debit Card Settings";
    return Feature;
  }({});
  _EventLogging.Feature = Feature;
  let CDP;
  (function (_CDP) {
    const eventString = (action, feature) => `${action} ${feature}`;
    const event = _CDP.event = args => {
      const feature = Feature.DebitCardSettings;
      return [eventString(args.action, feature), {
        ...args,
        applet: 'Banking',
        feature
      }];
    };
  })(CDP || (CDP = _EventLogging.CDP || (_EventLogging.CDP = {})));
})(EventLogging || (EventLogging = {}));
export default analytics([...events]);